<template>
  <div class="columns">
    <div class="column is-8 is-offset-2">
      <div class="card" @click="go">
      <div v-if="image" class="card-image">
        <figure class="image is-4by3">
          <img :src="image" :alt="title" @error="error.image = true">
        </figure>
      </div>
      <div class="card-content">
        <div class="media">
          <div class="media-content">
            <p class="title">{{title}}</p>
          </div>
        </div>
      </div>
      <div v-if="!iosIframeFix" class="content">{{trimmedDescription}}</div>
      <header v-if="!iosIframeFix" class="card-header">
        <div class="card-header-title">
          <figure v-if="favicon" class="image is-16x16"><img :src="favicon" :alt="site" @error="error.favicon = true"></figure>
          <span v-if="!favicon" class="icon"><i class="fal fa-link"></i></span>
          &nbsp;
          {{site}}
        </div>
      </header>
      </div>
    </div>
  </div>
</template>

<script>
import imageProxy from '@/libs/image-proxy'
import userAgent from '@/libs/user-agent'
import componentState from '@/mixins/component-state'

const maxDescr = 300

export default {
  props: ['attachment'],
  mixins: [componentState],
  data: function () {
    return {
      error: { favicon: false, image: false }
    }
  },
  computed: {
    metadata: function () {
      return this.attachment.metadata || {}
    },
    image: function () {
      return this.imageSrc ? imageProxy.proxy(this.imageSrc, { width: 515, height: 386 }) : '' // image is 4x3
    },
    imageSrc: function () {
      if (this.error.image) {
        return ''
      }

      if (this.metadata.ogImage) {
        return this.metadata.ogImage
      }

      if (this.metadata.screenshot) {
        return this.metadata.screenshot
      }

      return ''
    },
    description: function () {
      if (this.metadata.ogDescr) {
        return this.metadata.ogDescr
      }

      return this.metadata.descr
    },
    title: function () {
      if (this.metadata.ogTitle) {
        return this.metadata.ogTitle
      }

      return this.metadata.title
    },
    site: function () {
      if (this.metadata.ogName) {
        return this.metadata.ogName
      }

      const parts = this.metadata.url.match(/\/\/([^/]+)/)
      if (parts && parts.length > 1) {
        return parts[1]
      }

      return this.metadata.url
    },
    favicon: function () {
      return this.faviconSrc ? imageProxy.proxy(this.faviconSrc, {}) : ''
    },
    faviconSrc: function () {
      return !this.error.favicon ? this.metadata.favicon : ''
    },
    trimmedDescription: function () {
      let descr = this.description
      if (descr.length > maxDescr) {
        descr = `${descr.substring(0, maxDescr)}...`
      }
      return descr
    },
    iosIframeFix: function () {
      return !!this.$route.query.iframe && userAgent.isIOS()
    }
  },
  methods: {
    go: function () {
      window.open(this.attachment.url, '_blank')
      this._callback('logLinkClick', this.attachment.url)
    }
  }
}
</script>

<style lang="scss" scoped>
  .columns {
    padding: 0.5rem;
  }

  .card {
    cursor: pointer;
  }

  .title {
    font-size: 1.1rem;
    font-weight: 700;
    line-height: 1.5rem;
  }

  .content {
    padding: 0 1.5rem;
  }
</style>
